import { useEffect, useState } from "react";
import { STATUS_LABEL, type Bay } from "./bays";

/**
 * The FPV-lens page transition: a circle grows from the clicked drone's
 * camera lens until it swallows the screen. Live bays then navigate; unbuilt
 * bays open an honest workshop card inside the lens, and Back reverses the
 * wipe (the quad glides back onto its stand).
 */

const NOTE: Record<Bay["status"], string> = {
  live: "",
  building: "Parts are on the bench and the motors arrive soon.",
  planned: "Chalk marks on the floor. This bay gets built next.",
};

export function LensWipe({
  bay,
  x,
  y,
  onClose,
}: {
  bay: Bay;
  x: number;
  y: number;
  onClose: () => void;
}) {
  const [cover, setCover] = useState(false);
  const [card, setCard] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setCover(true));
    const href = bay.href;
    const t = window.setTimeout(() => {
      if (href) window.location.href = href;
      else setCard(true);
    }, href ? 780 : 640);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
    };
  }, [bay]);

  const back = () => {
    setCard(false);
    setCover(false);
    window.setTimeout(onClose, 520);
  };

  useEffect(() => {
    if (!card) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") back();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card]);

  const scale = cover ? Math.ceil(Math.hypot(window.innerWidth, window.innerHeight) / 6) : 0;

  return (
    <div className="wipe-layer">
      <div
        className="lens-wipe"
        style={{
          left: x + "%",
          top: y + "%",
          background: `radial-gradient(circle, ${bay.accent}b0 0%, #060810 55%, #04050c 100%)`,
          transform: `translate(-50%, -50%) scale(${scale})`,
        }}
      />
      {card && (
        <div className="bay-card">
          <span className="status">
            <span className={"dot " + bay.status} />
            {STATUS_LABEL[bay.status]}
          </span>
          <h2 className="bay-card-label">{bay.label}</h2>
          <p className="bay-card-tag">{bay.tagline}</p>
          <p className="bay-card-note">{NOTE[bay.status]}</p>
          <button className="bay-card-back" onClick={back}>
            Back to the flight line
          </button>
        </div>
      )}
    </div>
  );
}
